import { Injectable } from '@angular/core';
import { AuthService, FileHelperService } from '@app/services';
import { Roe } from '@models/payroll/roe.model';

@Injectable()
export class RoeService {
    constructor(
        private auth: AuthService,
        private fileHelper: FileHelperService
    ) {}

    async downloadPdf(roe: Roe): Promise<void> {
        return new Promise((resolve, reject) => {
            const url = `${this.auth.company.id}/roes/${roe.id}/downloadPdf`;
            this.fileHelper.savePayrollFile(url, `ROE_${roe.employeeFullName()}`, 'pdf', null, (e) =>
                e ? reject(e) : resolve()
            );
        });
    }
}
